<template>
  <header class="mb-4">
      <slot></slot>
  </header>
</template>
